module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "plates",
    attrs: {
      "id": "plates29"
    }
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "id": "plate29",
      "src": "images/plate29.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("More smiles for the camera chaps. Left to right: unknown, Wickham, D Wheeler, RWF, Dennis Monger, unknown, Ian Taylor, George Farries and Harold Leonard.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1997c6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_TallyHo_plates29.vue
// module id = 150
// module chunks = 0